export default __webpack_public_path__ + "static/media/next-js.48ddc812.png";